import { API } from "@project/shared"

export const getCompanyByUid = async ({ queryKey }) => {
  return API.get(`/companies/${queryKey[1]}`, { params: { is_fb_uid: true } })
}
